"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ra_data_simple_rest_1 = __importDefault(require("ra-data-simple-rest"));
var react_admin_1 = require("react-admin");
var RALayout_1 = __importDefault(require("@/Layouts/RALayout"));
var RAStyles_1 = require("../common/ReactAdmin/RAStyles");
var react_i18next_1 = require("react-i18next");
var Pagination_1 = __importDefault(require("../common/ReactAdmin/Pagination"));
var dist_1 = __importDefault(require("jsonexport/dist"));
var styles_1 = require("@mui/material/styles");
var Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var styles_2 = require("@mui/material/styles");
var StyledTooltipContent = (0, styles_2.styled)("pre")({
    whiteSpace: "pre-wrap",
    wordWrap: "break-word",
    maxWidth: "500px",
    overflow: "visible",
});
var TruncatedTextField = function (_a) {
    var source = _a.source;
    var record = (0, react_admin_1.useRecordContext)();
    if (!record)
        return null;
    var fullText = record[source] || "";
    var textToShow = fullText.length > 120 ? "".concat(fullText.substring(0, 120), "...") : fullText;
    return (react_1.default.createElement(Tooltip_1.default, { title: react_1.default.createElement(StyledTooltipContent, null, fullText), placement: "top", arrow: true },
        react_1.default.createElement(Typography_1.default, { "data-cy": "eventLogAction" }, textToShow)));
};
var exporter = function (users) {
    var usersForExport = users.map(function (user) { return ({
        name: user.name,
        action: user.text,
        userid: user.user_id,
        ip: user.ip,
        date: user.created_at,
    }); });
    (0, dist_1.default)(usersForExport, {
        headers: ["name", "action", "userid", "ip", "date"]
    }, function (err, csv) {
        if (err) {
            console.error("Export failed:", err);
            return;
        }
        (0, react_admin_1.downloadCSV)(csv, "event_history");
    });
};
var ListActions = function () { return (react_1.default.createElement(react_admin_1.TopToolbar, { className: "my-auto" },
    react_1.default.createElement(react_admin_1.ExportButton, { className: "my-auto", "data-cy": "eventLogExportButton" }))); };
var EventLogList = function (props) {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var eventFilters = [
        react_1.default.createElement(react_admin_1.SearchInput, { source: "global_search", alwaysOn: true, key: "globalSearchFilter", "data-cy": "eventLogSearchFilter" })
    ];
    return (react_1.default.createElement("div", { style: { marginTop: "60px", marginLeft: "60px", marginRight: "60px" } },
        react_1.default.createElement(react_admin_1.Admin, { dataProvider: (0, ra_data_simple_rest_1.default)("/api/list"), disableTelemetry: true, layout: RALayout_1.default },
            react_1.default.createElement(react_admin_1.Resource, { name: "eventLogs", list: react_1.default.createElement(react_admin_1.ListBase, __assign({}, props, { exporter: exporter, bulkActionButtons: false, perPage: 100 }),
                    react_1.default.createElement("div", { style: { marginBottom: "50px" } },
                        react_1.default.createElement(styles_1.ThemeProvider, { theme: RAStyles_1.RaSearchInputTheme },
                            react_1.default.createElement(react_admin_1.ListToolbar, { filters: eventFilters, actions: react_1.default.createElement(ListActions, null) }))),
                    react_1.default.createElement("div", { style: { marginTop: "30px" } },
                        react_1.default.createElement(styles_1.ThemeProvider, { theme: RAStyles_1.RaDatagridTheme },
                            react_1.default.createElement(react_admin_1.Datagrid, { "data-cy": "eventLogListRows", hover: false, sx: RAStyles_1.RaEventLogDataGridSx, bulkActionButtons: false },
                                react_1.default.createElement(react_admin_1.TextField, { source: "name", label: t("Name"), "data-cy": "eventLogName" }),
                                react_1.default.createElement(TruncatedTextField, { source: "text", label: t("Action") }),
                                react_1.default.createElement(react_admin_1.TextField, { source: "user_id", label: t("User Id"), "data-cy": "eventLogUserId" }),
                                react_1.default.createElement(react_admin_1.TextField, { source: "ip", label: t("IP"), "data-cy": "eventLogIp" }),
                                react_1.default.createElement(react_admin_1.TextField, { source: "created_at", label: t("Date(UTC)"), "data-cy": "eventLogDate" }))),
                        react_1.default.createElement(Pagination_1.default, { rowsPerPageOptions: [100, 250, 500, 1000] }))) }))));
};
exports.default = EventLogList;
